import React from 'react';
import { Tab } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import AigcBillContent from './AigcBillContent';
import ApiBill from './ApiBill';

const AigcBill = () => {
  const { t } = useTranslation();
  const panes = [
    {
      menuItem: t('bill.tabs.api'),
      render: () => (
        <Tab.Pane attached={false}>
          <ApiBill />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t('bill.tabs.aigc'),
      render: () => (
        <Tab.Pane attached={false}>
          <AigcBillContent />
        </Tab.Pane>
      ),
    },
  ];

  return <Tab panes={panes} defaultActiveIndex={0} />;
};

export default AigcBill;
